import { CSSProperties, FC } from 'react'
import classes from './index.module.css'
import { DragLineItemProps } from './types'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

interface LineItemProps extends DragLineItemProps {
  overlayItem?: boolean
}

const LineItem: FC<LineItemProps> = ({
  id,
  overlayItem,
  children,
  disabled,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled })

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? '100' : 'auto',
    opacity: isDragging ? 0.3 : 1,
  }

  return (
    <div ref={setNodeRef} style={style} className={classes.mainWrapper}>
      {children({
        overlayItem,
        dragElementProps: { ...attributes, ...listeners },
      })}
    </div>
  )
}

export default LineItem
